var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',[_c('h1',[_vm._v("404")]),_c('a',{attrs:{"href":"/"}},[_vm._v("Home")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }